/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setPinLength.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * ページURL取得
 */
var getPathName = location.pathname;
var pageName = /(access)/g;

/**
 * data-modalの割り当て調整
 */
const setPinLength = () => {
    if (getPathName.match(pageName)) {
        let modalTrigger = document.querySelectorAll(".info .js-modal-trigger");
        let dataPinArray = [];
        let dataSetPinArray = [];

        modalTrigger.forEach(function (element) {
            let dataModal = element.dataset.modal;
            dataPinArray.push(dataModal);
        })
        
        dataPinArray.forEach(function (element) {
            if (dataSetPinArray.indexOf(element) == -1) {
                dataSetPinArray.push(element);
            }
        })

        dataSetPinArray.forEach(function (element) {
            let index = 0;
            let modalTrigger = document.querySelectorAll(".info .js-modal-trigger[data-modal='" + element + "']");
            modalTrigger.forEach(function (element) {
                index++;
                element.dataset.modal = element.dataset.modal + '_' + index;
            })
        })
    }
}

export {
    setPinLength
}